var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShortPanel = function SvgShortPanel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    d: "M6.389 12.5h15.222c.491 0 .889.398.889.889v9.222a.89.89 0 0 1-.889.889H6.389a.89.89 0 0 1-.889-.889v-9.222c0-.491.398-.889.889-.889ZM5 16.5h18"
  })));
};
export default SvgShortPanel;